var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAllPage)?_c('v-chip',{attrs:{"label":"","small":"","color":_vm.color,"text-color":"white"}},[_vm._v("All")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }